import React, { useState } from 'react';
import SearchHeader from './SearchHeader/SearchHeader';
import SearchResult from './SearchResult/SearchResult';

const SearchProfile = props => {
  const { keyword } = props;
  const [type, setType] = useState('firmware');
  return (
    <div>
      <SearchHeader
        value={keyword}
        type={type}
        onTypeChange={v =>
          setType(v)
        }
      />
      <SearchResult
        value={keyword}
        type={type}
      />
    </div>
  );
};

export default SearchProfile;
